import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';

//-----------------------|| Loader ||-----------------------//

export interface LoaderProps extends LinearProgressProps {}

const Loader = () => {
    return (
        <div className="loader-container">
            <LinearProgress color="primary" />
        </div>
    );
};

export default Loader;
